/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, View, ScrollView } from "react-native";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import Icon from "react-icons-kit";
import { closeRound } from "react-icons-kit/ionicons/closeRound";
import { info } from "react-icons-kit/feather/info";
import parse from "html-react-parser";

import { Text } from "UpduoLibrary";
import {
  skaleBackgroundBlue,
  skaleBlack,
  skalePrimaryBlue,
  skaleTextGray,
} from "config/UpduoColors";

interface SkillDescriptionModalProps {
  isVisible: boolean;
  onClose: Function;
  skillName: string;
  skillDescription: string;
  isSkillPublished: boolean;
  communityName: string;
}

export default function SkillDescriptionModal({
  isVisible,
  onClose,
  skillName,
  skillDescription,
  isSkillPublished,
  communityName,
}: SkillDescriptionModalProps) {
  return (
    <Rodal
      visible={isVisible}
      onClose={() => onClose()}
      className={"rodal"}
      customStyles={{
        height: 250,
        width: 520,
        borderRadius: 12,
        padding: 25,
      }}
    >
      <View
        style={{
          flexDirection: "row",
        }}
      >
        <ScrollView
          style={{
            maxHeight: 25,
          }}
        >
          <Text
            isHeading={true}
            style={{
              fontSize: 18,
              color: skaleBlack,
            }}
          >
            {skillName}
          </Text>
        </ScrollView>
        <View
          style={{
            alignItems: "flex-end",
          }}
        >
          <TouchableOpacity onPress={() => onClose()}>
            <Text
              style={{
                color: skaleBlack,
              }}
            >
              <Icon size={20} icon={closeRound} />
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <ScrollView
        style={{
          height: 220,
          marginTop: 5,
        }}
      >
        {isSkillPublished ? null : (
          <View
            style={{
              backgroundColor: skaleBackgroundBlue,
              borderRadius: 10,
              flexDirection: "row",
              alignContent: "center",
              paddingVertical: 5,
              marginTop: 5,
            }}
          >
            <Text
              style={{
                color: skalePrimaryBlue,
                paddingRight: 10,
                paddingLeft: 5,
              }}
            >
              <Icon size={18} icon={info} />
            </Text>
            <Text style={{ color: skalePrimaryBlue, fontSize: 14 }}>
              {"This lesson is no longer available."}
            </Text>
          </View>
        )}
        <Text
          style={{
            fontSize: 16,
            color: skaleTextGray,
          }}
        >
          {parse(
            skillDescription
              .replace(/{SKILL_NAME}/g, skillName)
              .replace(/{COMMUNITY_NAME}/g, communityName)
          )}
        </Text>
      </ScrollView>
    </Rodal>
  );
}
